import { useMemo } from 'react';
import styled from '@emotion/styled';
import P1 from '@base/P1/P1';
import Paper from '@base/Paper/Paper';
import { getQuizDetails } from '@selectors/quizTaking';
import { useSelectorWithShallowEqual } from '@hooks/reduxHooks';
import { Spacings } from '@styles/index';
import Header from '@cont/Quiz/Taking/Navigation/Header';
import Questions from '@cont/Quiz/Taking/Navigation/Questions';
import { useRouter } from 'next/router';

const Wrapper = styled(Paper)`
  height: 100%;
  border-radius: 0;
  user-select: none;
  padding: ${Spacings.SPACING_3B} ${Spacings.SPACING_6B};
`;

const ButtomText = styled(P1)`
  opacity: 0.5;
  text-align: center;
  color: var(--color-text-secondary);
`;

const QuestionList = styled.div`
  overflow: scroll;
  overflow-x: hidden;
  height: calc(100vh - ${Spacings.SPACING_40B});

  scrollbar-width: none;

  ::-webkit-scrollbar {
    width: 0;
    background: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background: transparent;
  }
`;

const Navigation = () => {
  const {
    query: { quizUID }
  } = useRouter();

  const quizDetails = useSelectorWithShallowEqual(getQuizDetails(quizUID));

  const totalQuestions = useMemo(
    () =>
      quizDetails.sections?.reduce(
        (sum, { questions_count }) => sum + questions_count,
        0
      ),
    [quizDetails.sections]
  );

  const renderQuestionList = () => (
    <QuestionList>
      {quizDetails.sections?.map((section) => (
        <Questions
          key={section.uid}
          title={section.is_default ? 'Questions' : section.title}
          sectionUID={section.uid}
        />
      ))}
      {totalQuestions > 60 && (
        <ButtomText>• You have reached the end of the list •</ButtomText>
      )}
    </QuestionList>
  );

  return (
    <Wrapper>
      <Header />
      {renderQuestionList()}
    </Wrapper>
  );
};

export default Navigation;
